//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 885,
                    y: 710,
                    scale: 0.9
                },
                {
                    x: 900,
                    y: 180,
                    scale: 0.9
                },
                {
                    x: 840,
                    y: 410,
                    scale: 1
                },
                {
                    x: 1025,
                    y: 360,
                    scale: 0.7
                },
                {
                    x: 980,
                    y: 525,
                    scale: 0.7
                },
            ]
        };
    }
};
